module.exports = __webpack_public_path__ + "img/linea_de_vida.076a5413.svg";